module.exports = __webpack_public_path__ + "static/media/newLogo.d0547ab9.svg";